var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.6667 0.5H2.33341C1.41294 0.5 0.666748 1.24619 0.666748 2.16667V11.3333C0.666748 12.2538 1.41294 13 2.33341 13H2.75008C3.21031 13 3.58341 13.3731 3.58341 13.8333V15.921C3.58341 16.4534 4.17685 16.7711 4.61988 16.4757L8.57383 13.8397C9.39516 13.2922 10.3602 13 11.3473 13H15.6667C16.5872 13 17.3334 12.2538 17.3334 11.3333V2.16667C17.3334 1.24619 16.5872 0.5 15.6667 0.5Z",
    fill: "#5D78FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H4.83333C4.3731 8 4 8.3731 4 8.83333C4 9.29357 4.3731 9.66667 4.83333 9.66667H9C9.46024 9.66667 9.83333 9.29357 9.83333 8.83333C9.83333 8.3731 9.46024 8 9 8Z",
    fill: "#5D78FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 3.83325H4.83333C4.3731 3.83325 4 4.20635 4 4.66659C4 5.12682 4.3731 5.49992 4.83333 5.49992H13.1667C13.6269 5.49992 14 5.12682 14 4.66659C14 4.20635 13.6269 3.83325 13.1667 3.83325Z",
    fill: "#5D78FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.20ef48ee22554f35d202424794bc82f7.svg";
export { ForwardRef as ReactComponent };